import React from "react";
import { Box,  Typography, Grid, Paper } from "@mui/material";
import "./TeamPage.css";

const team = [
  {
    img: "", // blank (no profile picture)
    name: "Dr. Mohan S Gundeti",
    role: "Founder and Chief Surgeon, MD, MCh, FEBU, FRCS (Urol) FEAPU",
    description:
      "Dr. Mohan S. Gundeti is a globally recognized pediatric urological surgeon and innovator. He pioneered robotic-assisted reconstructive surgery in children and continues to lead advancements in pediatric urology and medical education worldwide.",
  },
  {
    img: "",
    name: "Dr. Madhav S Gundeti",
    role: "President and CEO",
    description:
      "Dr. Madhav S. Gundeti provides visionary leadership and strategic direction to the organization. With a strong background in healthcare management, he focuses on innovation, quality, and patient-centered growth.",
  },
  {
    img: "",
    name: "Aaryan M Gundeti",
    role: "Leadership Team",
    description:
      "Aaryan M. Gundeti plays a key role in the leadership team, contributing to organizational initiatives and innovation strategies aimed at advancing healthcare accessibility and community engagement.",
  },
  {
    img: "",
    name: "Mrs. Lalita M Gundeti",
    role: "Patient Liaison and Relationship",
    description:
      "Mrs. Lalita M. Gundeti is dedicated to ensuring compassionate care and strong communication between patients and healthcare teams. Her focus is on building trust and providing personalized patient support.",
  },
  {
    img: "",
    name: "Mr. Shriniwas Sabban",
    role: "Administrator, MBA",
    description:
      "Mr. Shriniwas Sabban manages daily administrative operations, combining business acumen with healthcare knowledge to maintain efficiency and excellence in service delivery.",
  },
  {
    img: "",
    name: "Sriniwas Samleti",
    role: "Administrator, MBA",
    description:
      "Sriniwas Samleti supports organizational administration with a focus on process improvement and effective resource management, ensuring smooth operational flow across departments.",
  },
  {
    img: "",
    name: "Ganesh Shriram",
    role: "Administrator",
    description:
      "Ganesh Shriram oversees essential administrative functions and coordinates between departments to uphold the organization’s high standards of performance and integrity.",
  },
  {
    img: "",
    name: "Rajesh",
    role: "Administrator, MBA",
    description:
      "Rajesh contributes to administrative leadership and strategic planning, ensuring that operational goals align with the institution’s mission and commitment to patient care.",
  },
];

const TeamPage = () => (
  <Box
    className="team-page-container"
    sx={{
      py: { xs: 6, md: 10 },
      backgroundColor: "#f8f9fa",
      minHeight: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      gap: 6,
      px: 2,
    }}
  >
    {/* Left side: CEO */}
    <Box
      className="team-page-ceo-card"
      sx={{
        backgroundColor: "#1e3a5f",
        color: "white",
        borderRadius: 2,
        p: 4,
        width: 280,
        textAlign: "center",
        flexShrink: 0,
        // height: 700,
      }}
    >
      <Box
        className="team-page-ceo-image"
        sx={{
          width: 190,
          height: 190,
          borderRadius: "50%",
          overflow: "hidden",
          border: "5px solid white",
          mx: "auto",
          mb: 3,
        }}
      >
        <img
          src={team[0].img}
          alt={team[0].name}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </Box>
      <Typography
        className="team-page-ceo-name"
        variant="h5"
        sx={{ fontWeight: 700, mb: 1, color: "#29abe2" }}
      >
        {team[0].name}
      </Typography>
      <Typography className="team-page-ceo-role" variant="h6" sx={{ mb: 2, fontWeight: "bold" }}>
        {team[0].role}
      </Typography>
      <Typography className="team-page-ceo-description" variant="body1" sx={{ fontSize: 15 }}>
        {team[0].description}
      </Typography>
    </Box>

    {/* Right side: Other team members */}
    <Box className="team-page-members-container" sx={{ flex: 1, maxWidth: 1200 }}>
      <Grid className="team-page-members-grid" container spacing={4} justifyContent="center">
        {team.slice(1).map((member) => (
          <Grid item xs={12} sm={6} md={3} key={member.name}>
            <Paper
              className="team-page-member-card"
              elevation={2}
              sx={{
                borderRadius: 2,
                textAlign: "center",
                p: 1,
                height: "100%",
              }}
            >
              <Box
                className="team-page-member-image"
                sx={{
                  width: 135,
                  height: 135,
                  borderRadius: "50%",
                  overflow: "hidden",
                  border: "4px solid #1991db",
                  mx: "auto",
                  mb: 2,
                }}
              >
                <img
                  src={member.img}
                  alt={member.name}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </Box>
              <Typography
                className="team-page-member-name"
                variant="h6"
                sx={{ fontWeight: 700, mb: 0.5, color: "#1a2f4b" }}
              >
                {member.name}
              </Typography>
              <Typography
                className="team-page-member-role"
                variant="subtitle2"
                sx={{ mb: 1, color: "#4fc3f7", fontWeight: 500 }}
              >
                {member.role}
              </Typography>
              <Typography
                className="team-page-member-description"
                variant="body2"
                sx={{ color: "#333", fontSize: 13, mx: "auto", maxWidth: 210 }}
              >
                {member.description}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  </Box>
);

export default TeamPage;
